import React from 'react'
import HeroImg from '../../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../../components/Constant/button/Button";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function AnjouanIBC() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Anjouan IBC (International Business Company)</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Offshore Incorporation in the Union of Comoros</h3>
                            <p className='page-paragraph'>
                                An <b>Anjouan IBC </b>provides a practical, affordable offshore company solution under the supervision of the <b> Anjouan Offshore Finance Authority (AOFA). </b>These companies are often chosen by startups, fintech entrepreneurs, and international operators seeking <b> speed, privacy, and low ongoing costs.</b>
                            </p>
                            <p className='page-paragraph'>
                                While recognition is not as high as Tier-1 jurisdictions, Western Sahara IBCs are often used by businesses seeking speed, <b>flexibility, and minimal costs.</b>
                            </p>

                            <PageList
                                items={[
                                    { title: "Fast Setup", icon: TiTick },
                                    { title: "Flexible", icon: TiTick },
                                    { title: "Cost-Efficient", icon: TiTick },
                                    { title: "License-Compatible", icon: TiTick },
                                ]}
                            />
                            <Button
                                text="Request an Anjouan IBC Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-subtitle'>Why Choose an Anjouan IBC?</h3>
                        <PageList
                            items={[
                                { title: "Affordable Incorporation — lower costs than Malta, Cyprus, or Isle of Man.", icon: GoDotFill },
                                { title: "Flexible Structure — suitable for holding, trading, or licensing.", icon: GoDotFill },
                                { title: "Privacy — owners not publicly listed.", icon: GoDotFill },
                                { title: "License Integration — required for Anjouan brokerage, gaming, and crypto licenses.", icon: GoDotFill },
                                { title: "Easy to Manage — simple renewals and no heavy compliance burden.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>
                            Key Features of Anjouan IBC
                        </h3>
                        <PageList
                            items={[
                                { title: "100% foreign ownership permitted.", icon: GoDotFill },
                                { title: "No minimum share capital required.", icon: GoDotFill },
                                { title: "At least 1 shareholder & 1 director (individual or corporate).", icon: GoDotFill },
                                { title: "Local registered agent & address mandatory.", icon: GoDotFill },
                                { title: "Confidentiality under AOFA regulations.", icon: GoDotFill },
                                { title: "Shares may be issued in multiple classes.", icon: GoDotFill },
                                { title: "Eligible to apply for financial services licenses.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Anjouan IBC</h3>
                        <PageList
                            items={[
                                { title: "Tax-Neutral — no local tax on offshore income.", icon: GoDotFill },
                                { title: "Light Compliance — limited reporting requirements.", icon: GoDotFill },
                                { title: "Banking & PSP Access — offshore-friendly structures.", icon: GoDotFill },
                                { title: "Sector-Specific Utility — commonly used for forex, gaming, and crypto licensing.", icon: GoDotFill },
                                { title: "Redomiciliation Friendly — can migrate in/out of Anjouan.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                { title: "1 shareholder & 1 director (can be the same).", icon: GoDotFill },
                                { title: "No residency requirement.", icon: GoDotFill },
                                { title: "Registered office & agent in Anjouan.", icon: GoDotFill },
                                { title: "KYC documents: passport, proof of address, CV.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                { title: "Consultation & Structuring — define shareholding & purpose.", icon: GoDotFill },
                                { title: "Name Reservation — check company name availability.", icon: GoDotFill },
                                { title: "Documentation — prepare Memorandum & Articles of Association.", icon: GoDotFill },
                                { title: "AOFA Filing — submit incorporation application.", icon: GoDotFill },
                                { title: "Certificate of Incorporation issued.", icon: GoDotFill },
                                { title: "Optional Services — nominees, apostilles, bank/PSP support.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "3–7 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From USD 2,000+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal",
                                    paragraph:
                                        "Government fees, agent, office, nominees (if used)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of Anjouan IBC</h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Holding company for shares and assets.",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Forex/crypto/gaming license base company.",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "E-commerce & online services company.",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting & advisory firm.",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Asset protection & IP holding.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Direct relationships with <b>AOFA & registered agents</b>",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Incorporation bundled with licensing if required",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Nominee, compliance & apostille services available",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Banking introductions for <b>offshore-friendly PSPs.</b>",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Anjouan vs Mwali vs Western Sahara vs Seychelles",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a fast, affordable offshore company?"
                        description="An <b>Anjouan IBC</b> offers privacy, speed, and flexibility — ideal for pairing with licenses in <b>forex, gaming, crypto, and banking.</b>"
                        buttonText="Book an Anjouan IBC Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default AnjouanIBC

const faqData = [
    {
        question: "How long does it take to incorporate an Anjouan IBC?",
        content: [
            { type: "answer", text: "Usually 3–7 business days." },
        ],
    },
    {
        question: "Is there a minimum capital requirement?",
        content: [
            { type: "answer", text: "No — zero paid-up capital required." },
        ],
    },
    {
        question: "Can I use one for forex or gaming?",
        content: [
            { type: "answer", text: "Yes — an Anjouan IBC is the required entity for licensing." },
        ],
    },
    {
        question: "Do I need local directors?",
        content: [
            { type: "answer", text: "No, directors/shareholders can be foreign." },
        ],
    },
    {
        question: "Where can I bank with an Anjouan IBC?",
        content: [
            { type: "answer", text: "Bank accounts are typically opened abroad (UAE, Mauritius, Seychelles, Europe)." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "We registered an Anjouan IBC to hold our brokerage license. Offshore Advisory handled everything smoothly.",
        author: "Farid M.",
        role: "Forex CEO",
    },
    {
        quote:
            "Anjouan IBCs are simple and affordable. Offshore Advisory gave us the full package with nominees and apostille.",
        author: "Elena V.",
        role: "FinTech Entrepreneur",
    },
];